<template>
  <component
    :is="stepComponent">
  </component>
</template>

<script setup>

import { reactive, computed, ref, defineExpose } from 'vue'

import Step1 from "@/components/builder/products/wardrobes/TypeAndLayout.vue";
import SlidingStep2 from "@/components/builder/products/wardrobes/sliding/WallSpace.vue";
import SlidingStep3 from "@/components/builder/products/wardrobes/sliding/Size.vue";
import SlidingStep4 from "@/components/builder/products/wardrobes/sliding/Design.vue";
import WalkinStep2 from "@/components/builder/products/wardrobes/walkin/WallSpace.vue";
import WalkinStep3 from "@/components/builder/products/wardrobes/walkin/Sections.vue";
import WalkinStep4 from "@/components/builder/products/wardrobes/walkin/Design.vue";
import Sliding2Step2 from "@/components/builder/products/wardrobes/sliding2/WallSpace.vue";
import Sliding2Step3 from "@/components/builder/products/wardrobes/sliding2/Size.vue";
import Sliding2Step4 from "@/components/builder/products/wardrobes/sliding2/Design.vue";
import Sliding2Prepare from "@/components/builder/products/wardrobes/sliding2/Prepare.vue";
import HingedStep2 from "@/components/builder/products/wardrobes/hinged/WallSpace.vue";
import HingedStep3 from "@/components/builder/products/wardrobes/hinged/Size.vue";
import HingedStep4 from "@/components/builder/products/wardrobes/hinged/Doors.vue";
import HingedStep5 from "@/components/builder/products/wardrobes/hinged/Sections.vue";
import HingedStep6 from "@/components/builder/products/wardrobes/hinged/Design.vue";
import CustomWardrobeStep2 from "@/components/builder/products/custom/Details.vue";
import CustomWardrobeStep3 from "@/components/builder/products/custom/Design.vue";
import Quote from "@/components/builder/Quote.vue";

const comps = {
  Step1,
  SlidingStep2,
  SlidingStep3,
  SlidingStep4,
  WalkinStep2,
  WalkinStep3,
  WalkinStep4,
  Sliding2Step2,
  Sliding2Step3,
  Sliding2Step4,
  Sliding2Prepare,
  HingedStep2,
  HingedStep3,
  HingedStep4,
  HingedStep5,
  HingedStep6,
  CustomWardrobeStep2,
  CustomWardrobeStep3,
  Quote,
};

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const stepComponent = computed(() => {
  if (builder.mode == 'quote') return comps['Quote'];
  if (builder.mode == 'prepare') {
    return comps['Sliding2Prepare'];
  }
  if (builder.step <= 1) return comps[builder.stepComponentName]
  else return comps[builder.currentProductHandle + builder.stepComponentName]
})

</script>
